module.exports = __webpack_public_path__ + "static/media/logo-topazio-receipt.d711e18c.png";